export default __webpack_public_path__ + "static/media/formula.f0f85248.svg";